// src/sidebar/SidebarData.js
import { FaEdit, FaTachometerAlt } from 'react-icons/fa';

export const SidebarData = [
  {
    title: 'Home',
    path: '/',
    icon: <FaEdit className="text-xl" />,
  },
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: <FaTachometerAlt className="text-xl" />,
  },
];